//Action Types
export const AddressIssueTypes_ActionsTypes = { 
    FETCH_AddressIssueTypes_REQUEST : 'FETCH_AddressIssueTypes_REQUEST',
    FETCH_AddressIssueTypes_SUCCESS : 'FETCH_AddressIssueTypes_SUCCESS',
    FETCH_AddressIssueTypes_FAILURE : 'FETCH_AddressIssueTypes_FAILURE'
}

//Actions
export const fetchAddressIssueTypesRequest = () => {
    return {
      type: AddressIssueTypes_ActionsTypes.FETCH_AddressIssueTypes_REQUEST
    };
  };
  
  export const fetchAddressIssueTypesSuccess = (data) => {
    return {
      type: AddressIssueTypes_ActionsTypes.FETCH_AddressIssueTypes_SUCCESS,
      payload: data,
    };
  };
  
  export const fetchAddressIssueTypesFailure = (error) => {
    return {
      type: AddressIssueTypes_ActionsTypes.FETCH_AddressIssueTypes_FAILURE,
      payload: error,
    };
  };
  
  const initialState = {
    data : [],
    loading : false,
    error  : ''
}

  //Reducer 
  export const addressIssueTypesReducer = (state = initialState , {type, payload})=>{
      switch (type) {
        case AddressIssueTypes_ActionsTypes.FETCH_AddressIssueTypes_REQUEST:
          return {
              ...state,
              data : [],
              loading : true,
              error : ''
          }

        case AddressIssueTypes_ActionsTypes.FETCH_AddressIssueTypes_SUCCESS:
            return {
                ...state,
                data : payload,
                loading : false,
                error : ''
            }

        case AddressIssueTypes_ActionsTypes.FETCH_AddressIssueTypes_FAILURE:
            return {
                ...state,
                data : [],
                loading : false,
                error : payload
            }

        default:
          return state;
      }
        
  }
  

